module.exports = __webpack_public_path__ + "img/edit.8b95e996.svg";